export default __webpack_public_path__ + "maps-guides-view-annotation-z-index-1200-6106a87cb3c882524488ac46d2f20e8a.webp";